// extracted by mini-css-extract-plugin
export default {"dashboard":"vUG96mGWvq4lQ6XQfDIb","container":"M_XJ1hPW3cTCoQo1y6S7","todoContainer":"JFoJAOdOs0_CxFI_WVjo"};